﻿import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { RawMaterial } from '../../models/RawMaterials/raw-material';
import { RawMaterialBatch } from '../../models/raw-material-batch';
import { RawMaterialContainer } from '../../models/Production/raw-material-container';
import { LookupItem } from '../../models/lookup-item';
import { Entities } from '../../models/enums';
import { Vendor } from '../../models/vendor';
import { AuditProps } from '../../models/audit-props';
import { ToastProps } from '../../models/toast-props';
import { SymbolEditorProps } from '../../models/symbol-editor-props';
import { Decimal4Format } from '../../templates/pw-formatting';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import AuditHistoryComponent from '../AuditHistoryComponent';
import { CrudFunctions } from '../../utilities/crud-functions';
import { UserDataStore } from '../../store/userDataStore';
import TicketLogEntryForm from '../TicketLogEntryForm';
import { DocumentationConstants } from '../../store/documentation-constants';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';
import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    FilterRow,
    Pager,
    Paging,
    Selection,
    HeaderFilter,
    Button as ColumnButton,
    Item as ToolbarItem,
    Toolbar,
    Scrolling,
    SearchPanel,
    LoadPanel,
    Popup,
    Form,
    Lookup,
    Editing
} from 'devextreme-react/data-grid';

import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Toast } from 'devextreme-react/toast';
import { Item } from 'devextreme-react/form';

let key = 1;

export default function RawMaterialsForm() {
    const [vendors, setVendors] =
        useState<Vendor[]>();

    const [uoms, setUoms] =
        useState<LookupItem[]>();

    const [containerTypes, setContainerTypes] =
        useState<LookupItem[]>();

    const [rawMaterials, setRawMaterials] =
        useState<RawMaterial[]>();

    const [selectedRawMaterial, setSelectedRawMaterial] =
        useState<RawMaterial>();

    const [rawMaterialSearchFilter, setRawMaterialSearchFilter] =
        useState<string>();

    const [rawMaterialBatches, setRawMaterialBatches] =
        useState<RawMaterialBatch[]>();

    const [selectedRawMaterialBatch, setSelectedRawMaterialBatch] =
        useState<RawMaterialBatch>();

    const [rawMaterialBatchContainers, setRawMaterialBatchContainers] =
        useState<RawMaterialContainer[]>();

    const [selectedRawMaterialBatchContainer, setSelectedRawMaterialBatchContainer] =
        useState<RawMaterialContainer>();

    const [auditInformationDialogVisible, setAuditInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [auditProps, setAuditProps] =
        useState<AuditProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const parts = window.location.href.split('/');
    let rawMaterialId;

    if (parts) {
        const lastPart = parts[parts.length - 1];

        if (lastPart && lastPart.toLowerCase() !== "rawmaterialsform")
            rawMaterialId = lastPart;
    }

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getRawMaterialBatches();
    }, [selectedRawMaterial]);

    useEffect(() => {
        getRawMaterialBatchContainers();
    }, [selectedRawMaterialBatch]);

    key++;

    const user = UserDataStore.getCurrentUser();
    const canEditRoles = ["SA", "RM-A", "RM-L", "RM-T"];
    /*
    const canEdit = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));
    const canInsertRoles = ["SA", "RM-A", "RM-L"];
    const canInsert = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));
    const canDeleteRoles = ["SA", "RM-A"];
    const canDelete = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));
    */

    return (
        <div className="pw-content">
            <div className="lq-title-bar">
                <div className="lq-main-title">Chemical Inventory Items {rawMaterialId && '(filtered)'}</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button className="title-bar-button"
                            text="" icon="tel" type="normal"
                            hint="report issue"
                            onClick={showTicketLogEntryDialog} />
                    </div>
                    <div>
                        <NavLink to={`/documentation/${DocumentationConstants.RawMaterialsForm}`}
                            className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                            <Button className="title-bar-button pw-orange"
                                text="" icon="help" type="normal"
                                hint="help and documentation" />
                        </NavLink>
                    </div>
                    <div>
                        <Button className="title-bar-button"
                            text="" icon="arrowleft" type="normal"
                            hint="go back"
                            onClick={goBack} />
                    </div>
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-comp-15">
                    <div className="pw-form-unit-label">Search by key word:</div>
                    <TextBox id="txtRawMaterialSearch" className="textbox"
                        width={'20em'}
                        onValueChanged={rawMaterialSearchFilterChanged}
                        placeholder="search by item#" value={rawMaterialSearchFilter} />
                </div>

                <div className="pw-margin-top-08">
                    <Button id="searchButton" text="Search" type="success"
                        className="pw-margin-left-05"
                        onClick={searchButtonClicked} />

                </div>
            </div>

            <div id="rawmaterials-datagrid-container">
                <DataGrid id="rawMaterialsDataGrid"
                    elementAttr={{ id: "rawMaterialsDatagrid" }}
                    keyExpr="productId"
                    height="12rem"
                    wordWrapEnabled={true}
                    dataSource={rawMaterials ? rawMaterials : []}
                    onSelectionChanged={rawMaterialSelectionChanged}
                    onRowValidating={onRawMaterialRowValidating}
                    allowColumnResizing={true}
                    columnResizingMode="nextColumn"
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <SearchPanel visible={true} />
                    <Scrolling showScrollbar='always' />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />

                    <Column type="buttons" width="7rem">
                        <ColumnButton name="edit" />
                        <ColumnButton name="delete" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onRawMaterialAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onRawMaterialInformationButtonClicked} />
                    </Column>

                    <Column dataField='partNumber' width="10rem" caption="Part#" dataType="string" />
                    <Column dataField='casNumber' width="8rem" caption="CAS#" dataType="string" />
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Part Match</div>
                            </div>
                        </ToolbarItem>
                        <ToolbarItem name="searchPanel" location='after' />
                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={false}
                        allowUpdating={true}
                        allowDeleting={false}>

                        <Popup title="Raw Material" showTitle={true} width="80vw" height="80vh" />
                        <Form>
                            <Item dataField="partNumber" />
                            <Item dataField="vendorId" />
                            <Item dataField="vendorPartNumber" />
                            <Item dataField="vendorPartName" />
                            <Item dataField="casNumber" />

                        </Form>
                    </Editing>

                </DataGrid>
            </div>

            <div id="rawmaterialsbatches-datagrid-container" className="pw-margin-top-1">
                <DataGrid
                    height="16rem"
                    elementAttr={{ id: "rawMaterialBatchesDatagrid" }}
                    wordWrapEnabled={true}
                    dataSource={rawMaterialBatches ? rawMaterialBatches : []}
                    onRowValidating={onRawMaterialBatchRowValidating}
                    onSelectionChanged={onRawMaterialBatchSelectionChanged}
                    allowColumnResizing={true}
                    columnResizingMode="widget"
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />

                    <Column type="buttons" width="7rem">
                        <ColumnButton name="edit" />
                        <ColumnButton name="delete" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onRawMaterialBatchAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onRawMaterialBatchInformationButtonClicked} />
                    </Column>

                    <Column dataField='batchName' dataType="string" width='10rem'
                        cssClass="table-vertical-align" />

                    <Column dataField='vendorName' caption="Vendor" width='10rem' />
                        {/*
                        <Lookup dataSource={vendors ? vendors : []}
                            displayExpr='name'
                            valueExpr='vendorId' />
                    </Column>
                    */}

                    <Column dataField='vendorPartNumber' width="10rem" caption="Vendor Part#" dataType="string" />
                    <Column dataField='vendorPartName' caption="Vendor Part Name" dataType="string" />

                    <Column dataField='purity' dataType="number"
                        format={Decimal4Format} width='8rem' cssClass="table-vertical-align" />
                    <Column dataField='stockConcentrationPercentPpm' dataType="number" caption="Stock Conc. % PPM"
                        format={Decimal4Format} width='9rem' cssClass="table-vertical-align" />
                    <Column dataField='concentration' dataType="number"
                        format={Decimal4Format} width='8rem' cssClass="table-vertical-align" />
                    <Column dataField='density' dataType="number"
                        format={Decimal4Format} width='8rem' cssClass="table-vertical-align" />

                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Chemical Inventory Items</div>
                            </div>
                        </ToolbarItem>
                        <ToolbarItem location='after' name="addRowButton" />

                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true}>

                        <Popup title="Raw Material Batch" showTitle={true} width="80vw" height="80vh" />
                        <Form>
                            <Item dataField="batchName" />
                            <Item dataField="purity" />
                            <Item dataField="stockConcentrationPercentPpm" />
                            <Item dataField="concentration" />
                            <Item dataField="density" />

                        </Form>
                    </Editing>

                </DataGrid>
            </div>

            <div className="pw-margin-top-1">
                <DataGrid
                    height="16rem"
                    elementAttr={{ id: "rawMaterialContainersDatagrid" }}
                    wordWrapEnabled={true}
                    dataSource={rawMaterialBatchContainers ? rawMaterialBatchContainers : []}
                    onRowValidating={onRawMaterialContainerRowValidating}
                    keyExpr="rawMaterialContainerId"
                    allowColumnResizing={true}
                    columnResizingMode="widget"
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />

                    <Column type="buttons" width="7rem">
                        <ColumnButton name="edit" />
                        <ColumnButton name="delete" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onRawMaterialContainerAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onRawMaterialContainerInformationButtonClicked} />
                    </Column>

                    <Column dataField='containerName' caption="Name" dataType="string" width='10rem' />

                    <Column dataField='containerType' caption="Type" width="10rem" dataType="number">
                        <Lookup dataSource={containerTypes ? containerTypes : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='id' />
                    </Column>

                    <Column dataField='expirationDate' dataType="date" width='10rem' />
                    <Column dataField='openedDate' dataType="date" width='10rem' />
                    <Column dataField='size' dataType="number" width='10rem' />

                    <Column dataField='uom' width="10rem" dataType="number">
                        <Lookup dataSource={uoms ? uoms : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='id' />
                    </Column>

                    <Column allowEditing={false} />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Batch Containers</div>
                            </div>
                        </ToolbarItem>
                        <ToolbarItem name="addRowButton" disabled={!selectedRawMaterialBatch} location='after' />
                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true}>
                    </Editing>

                </DataGrid>
            </div>

            <DmaFooter />

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {auditInformationDialogVisible &&
                <DialogPopup visible={auditInformationDialogVisible}
                    onHiding={hideAuditInformationDialog}
                    title="Audit History"
                    minWidth={'50em'}
                    minHeight={'32em'}
                    hideOnOutsideClick={false}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <AuditHistoryComponent entityNumber={auditProps && auditProps.entity ?
                        auditProps.entity : undefined}
                        key={`AuditHistory${key}`}
                        childData={auditProps && auditProps.informationShowChildData ?
                            auditProps.informationShowChildData : undefined}
                        rowPointer={auditProps && auditProps.rowPointer ?
                            auditProps.rowPointer : undefined} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    hideOnOutsideClick={false}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Raw Materials" contextData={selectedRawMaterial}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function rawMaterialSearchFilterChanged(e: any) {
        setRawMaterialSearchFilter(e.value);
    }

    function rawMaterialSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedRawMaterial(e.selectedRowsData[0]);
    }

    function onRawMaterialBatchSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedRawMaterialBatch(e.selectedRowsData[0]);
    }

    function searchButtonClicked(e: any) {
        if (rawMaterialSearchFilter && rawMaterialSearchFilter.length > 2)
            getRawMaterials(rawMaterialSearchFilter);
    }

    async function onRawMaterialRowValidating(e: any) {
        if (e.oldData) {
            let rawMaterial = e.oldData as RawMaterial;

            if (rawMaterial) {
                let updatedRawMaterial = { ...rawMaterial, ...e.newData };

                updateRawMaterial(updatedRawMaterial)
                    .then(() => {
                        showToast("Raw Material updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Raw Material");
                    });
            }
        }
        else {
            if (e.newData) {
                let rawMaterial = e.newData as RawMaterial;

                rawMaterial.productId = selectedRawMaterial.productId;

                await insertRawMaterial(rawMaterial)
                    .then(() => {
                        showToast("Raw Material saved", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Raw Material");
                    });
            }
        }
    }

    async function onRawMaterialBatchRowValidating(e: any) {
        if (e.oldData) {
            let rawMaterialBatch = e.oldData as RawMaterialBatch;

            if (rawMaterialBatch) {
                let updatedRawMaterialBatch = { ...rawMaterialBatch, ...e.newData };

                updateRawMaterialBatch(updatedRawMaterialBatch)
                    .then(() => {
                        showToast("Raw Material Batch updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Batch");
                    });
            }
        }
        else {
            if (e.newData) {
                let rawMaterialBatch = e.newData as RawMaterialBatch;

                rawMaterialBatch.productId = selectedRawMaterial.productId;

                await insertRawMaterialBatch(rawMaterialBatch)
                    .then(() => {
                        showToast("Raw Material Batch saved", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Batch");
                    });
            }
        }
    }

    async function onRawMaterialContainerRowValidating(e: any) {
        if (e.oldData) {
            let rawMaterialContainer = e.oldData as RawMaterialContainer;

            if (rawMaterialContainer) {
                let updatedRawMaterialContainer = { ...rawMaterialContainer, ...e.newData };

                updateRawMaterialContainer(updatedRawMaterialContainer)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Raw Material Container");
                    });
            }
        }
        else {
            if (e.newData) {
                let rawMaterialContainer = e.newData as RawMaterialContainer;

                if (rawMaterialContainer) {
                    rawMaterialContainer.batchId = selectedRawMaterialBatch.rawMaterialBatchId;

                    await insertRawMaterialContainer(rawMaterialContainer)
                        .then(() => {
                            getRawMaterialBatchContainers();
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Raw Material Container");
                        });
                }
            }
        }
    }

    //get functions

    async function getContainerTypes() {
        await CrudFunctions.getData("common/containertypes")
            .then(data => {
                setContainerTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Container Types");
            });
    }

    async function getUoms() {
        await CrudFunctions.getData("common/uoms")
            .then(data => {
                setUoms(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving UOMs");
            });
    }

    async function getRawMaterials(itemSearch: string) {
        await CrudFunctions.getData(`products/rawmaterials/${itemSearch}`)
            .then(data => {
                setRawMaterials(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Raw Materials");
            });
    }

    async function getRawMaterialBatches() {
        if (selectedRawMaterial && selectedRawMaterial.productId) {
            CrudFunctions.getData(`products/rawmaterialbatches/${selectedRawMaterial.productId}`)
                .then(data => {
                    setRawMaterialBatches(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Raw Material Batches");
                });
        }
    }

    async function getRawMaterialBatchContainers() {
        if (selectedRawMaterialBatch && selectedRawMaterialBatch.rawMaterialBatchId) {
            CrudFunctions.getData(`products/rawmaterialcontainers/${selectedRawMaterialBatch.rawMaterialBatchId}`)
                .then(data => {
                    setRawMaterialBatchContainers(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Raw Material Batch Container");
                });
        }
    }

    /*
    async function getVendors() {
        await CrudFunctions.getData("common/vendors")
            .then(data => {
                setVendors(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Vendors");
            });
    }
    */

    async function insertRawMaterial(rawMaterial: RawMaterial) {
        return await CrudFunctions.postData("products/rawmaterial", rawMaterial);
    }

    async function insertRawMaterialBatch(batch: RawMaterialBatch) {
        return await CrudFunctions.postData("products/productrawmaterialbatch", batch);
    }

    async function insertRawMaterialContainer(rawMaterialContainer: RawMaterialContainer) {
        return await CrudFunctions.postData("products/rawmaterialcontainer", rawMaterialContainer);
    }

    async function updateRawMaterial(rawMaterial: RawMaterial) {
        return await CrudFunctions.putData("products/rawmaterial", rawMaterial);
    }

    async function updateRawMaterialBatch(batch: RawMaterialBatch) {
        return await CrudFunctions.putData("products/productrawmaterialbatch", batch);
    }

    async function updateRawMaterialContainer(rawMaterialContainer: RawMaterialContainer) {
        return await CrudFunctions.putData("products/rawmaterialcontainer", rawMaterialContainer);
    }

    //navigation

    /*
    function goToRawMaterialAnalysisFormCellRender(e: any) {
        if (e.data) {
            let batch = e.data as ProductBatchListItem;

            if (batch && batch.batchId) {
                let path = `/rawmaterialanalysis/${batch.batchId}`;
                return <NavLink to={path} className="datagrid-icon-link"><span className="dx-icon-importselected datagrid-icon"></span></NavLink>
            }
            else
                return <div></div>;
        }

        return <div></div>;
    }
    */

    async function getAllData() {
        await Promise.all([
            getUoms(),
            getContainerTypes()
            //getVendors()
        ]);
    }

    function goBack() {
        history.back();
    }

    function onRawMaterialAuditButtonClicked(e: any) {


    }

    function onRawMaterialInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: e.row.data.productId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemInformation);
            showItemBasicInformationDialog();
        }
    }

    function onRawMaterialBatchAuditButtonClicked(e: any) {

    }

    function onRawMaterialBatchInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: e.row.data.rawMaterialBatchId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemInformation);
            showItemBasicInformationDialog();
        }
    }

    function onRawMaterialContainerAuditButtonClicked(e: any) {

    }

    function onRawMaterialContainerInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: e.row.data.rawMaterialContainerId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemInformation);
            showItemBasicInformationDialog();
        }
    }

    // show/hide

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function hideAuditInformationDialog() {
        setAuditInformationDialogVisible(false);
    }

    function showItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(true);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(true);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function showRawMaterialsAuditDialog(e: any) {
        if (e.row && e.row.data) {
            const auditParams: AuditProps = {
                entity: Entities.RawMaterials,
                rowPointer: e.row.data.rawMaterialId,
                informationShowChildData: false,
            };

            setAuditProps(auditParams);
            setAuditInformationDialogVisible(true);
        }
    }

    function showRawMaterialBatchesAuditDialog(e: any) {
        if (e.row && e.row.data) {
            const auditParams: AuditProps = {
                entity: Entities.RawMaterialBatches,
                rowPointer: e.row.data.rawMaterialBatchId,
                informationShowChildData: false,
            }

            setAuditProps(auditParams);
            setAuditInformationDialogVisible(true);
        }
    }

    function onRawMaterialsInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemBasicInformation: ItemBasicInformation = {
                rowPointer: e.row.data.rawMaterialId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemBasicInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function onRawMaterialBatchesInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemBasicInformation: ItemBasicInformation = {
                rowPointer: e.row.data.rawMaterialBatchId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemBasicInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    //file

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}

